import { tToastNotificationAction, OPEN_TOAST_NOTIFICATION, CLOSE_TOAST_NOTIFICATION } from "./actions"

export type NotificationState = {
    open: boolean
    message: string
    type: "info" | "error" | "warning" | "success"
    expires_at?: number
}

const initToastNotification: NotificationState = {
    open: false,
    message: "",
    type: "info",
}

const toastNotification = (
    state: NotificationState = initToastNotification,
    action: tToastNotificationAction
): NotificationState => {
    switch (action.type) {
        case OPEN_TOAST_NOTIFICATION:
            return {
                ...state,
                open: true,
                message: action.message,
                type: action.toastType,
                expires_at: action.expires_at,
            }
        case CLOSE_TOAST_NOTIFICATION:
            return { ...initToastNotification }
        default:
            return state
    }
}

export default toastNotification
